export default {
    // Header
    "contact": "Contact",
    "us": "Us",
    "contact_description": "Have a question, feedback, or want a personalized consultation? Reach out and we'll respond within 24–48 hours.",

    // Contact Info Section
    "email": "Email",
    "phone_whatsapp": "WhatsApp",
    "chat_on_whatsapp": "Chat on WhatsApp",
    "follow_us": "Follow Us",

    // Form Labels
    "full_name": "Full Name",
    "email_address": "Email Address",
    "phone_number": "Phone Number",
    "subject": "Subject",
    "message": "Message",

    // Form Placeholders
    "enter_full_name": "Enter your full name",
    "email_placeholder": "you@email.com",
    "phone_placeholder": "Optional: +91 xxxxx-xxxxx",
    "subject_placeholder": "What can we help you with?",
    "message_placeholder": "Tell us how we can help with your astrological needs...",

    // Form Actions
    "send_message": "Send Message",
    "message_sent_success": "Message Sent! ✓",
    "thank_you_message": "Thank you for contacting us! We'll get back to you within 24-48 hours."

}